import { isTrackingDisabled } from ".";

// Session recording is only wanted on real customer-facing environments,
// not on alpha/dev builds (which Vite still builds in "production" mode).
const LOGROCKET_ENVIRONMENTS = ["staging", "production"];

export const isLogRocketEnabled = () => {
  return (
    import.meta.env.VITE_APP_LOGOROCKET_ID &&
    import.meta.env.MODE !== "development" &&
    LOGROCKET_ENVIRONMENTS.includes(__CONFIG_ENVIRONMENT__) &&
    (import.meta.env.MODE === "production" || !isTrackingDisabled())
  );
};
